import { generatedApi } from './api.generated';
import { createEndpointExports, createHookExports } from '@skynet/data-helpers';
import type { HookExports } from '@skynet/data-helpers';
import { DEX_ADD_VAULTS_API_ENDPOINTS as cfg } from './config';

const enhancedDexAddVaultsApi = generatedApi.enhanceEndpoints({
  addTagTypes: ['DexAddVaultToken', 'DexPool'],
  endpoints: {
    [cfg.getQuoteTokens.generated]: {
      providesTags: (_, __, arg) => [{ type: 'DexAddVaultToken', id: arg.blockchainId }],
    },
    [cfg.formatTokenAddress.generated]: {
      providesTags: (_, __, arg) => [
        {
          type: 'DexAddVaultToken',
          id: `${arg.blockchainId}-${arg.address}`,
        },
      ],
    },
    [cfg.getPool.generated]: {
      providesTags: (_, __, arg) => [
        {
          type: 'DexPool',
          id: `${arg.exchangeId}-${arg.quoteToken ?? ''}-${arg.baseToken ?? ''}-${arg.poolFee ?? 0}`,
        },
      ],
    },
  },
});

export const dexAddVaultsApi: typeof enhancedDexAddVaultsApi = enhancedDexAddVaultsApi;

export const hookExports: HookExports<typeof cfg, typeof dexAddVaultsApi> = createHookExports(
  cfg,
  dexAddVaultsApi,
);

const endpointExports = createEndpointExports(cfg, dexAddVaultsApi);

export const dexAddVaultsApiEndpoints: typeof endpointExports = endpointExports;
